import { WSIcons } from "../../commonFunctions/iIcons";

export const getMenu: any = (userType: string) => {
  return {
    staticMenu:
      userType === "pharmacy"
        ? [
          {
            id: 1,
            label: "OverView",
            icon: WSIcons.OverViewIcon,
            path: "/dashboard",
          },
          {
            id: 28,
            label: "Pharmacy Order ",
            path: "/pharmacy-orders/list",
            icon: WSIcons.OverViewIcon,
          },
          {
            id: 6,
            label: "Payment",
            icon: WSIcons.OrdersIcon,
           
            path: "/payment/list",
            

          },

          {
            id: 32,
            label: "Technician Managment",
            path: "/technician-management/list",
            icon: WSIcons.OverViewIcon,
          },
          {
            id: 2,
            label: "My Products",
            icon: WSIcons.ProductIcon,
            children: [
              {
                id: 21,
                label: "Product",
                path: "/vendor-product/list",
              },
              // {
              //   id: 28,
              //   label: "Product View",
              //   path: "/vendor-product-view",
              // },

              {
                id: 27,
                label: "Vendor Type",
                path: "/vendortype/list",
              },
            ],
          },
        ]
        :
        [
          // {
          //   id: 3,
          //   label: "OverView",
          //   icon: WSIcons.OverViewIcon,
          //   path: "/dashboard",
          // },
          {
            id: 36,
            label: "Lab Overview",
            path: "/lab-overview",
            icon: WSIcons.OverViewIcon,
          },
          
          
         

          {
            id: 5,
            label: " Orders",
            icon: WSIcons.OrdersIcon,
            path: "/lab-orders/list"

            // children: [
            //   {
            //     id: 22,
            //     label: "Lab Orders ",
            //     path: "/lab-orders/list",
            //   },
            

            // ],
          },
          {
            id: 21,
            label: "Lab Test & Packages ",
            path: "/labtestpackage/list",
            icon: WSIcons.OverViewIcon,
          },
          {
            id: 58,
            label: "Schedules ",
            path: "/lab-schedule",
            icon: WSIcons.OverViewIcon,
          },
           {
              id: 6,
              label: " Revenue & Payment",
              icon: WSIcons.OrdersIcon,
              path: "/revenue-payments",

              // children: [
              //   // {
              //   //   id: 25,
              //   //   label: "Revenue & Payment Details ",
              //   //   path: "/revenue-details",
              //   // },
              //   {
              //     id: 26,
              //     label: "Revenue & Payment ",
              //     path: "/revenue-payments",
              //   },
                
              // ],
              
            },
           
             {
            id: 37,
            label: "Lab Technician Management",
            path: "/lab-technician-manage/list",
            icon: WSIcons.OverViewIcon,
          },


          {
            id: 21,
            label: "Lab Report",
            path: "/lab-report/list",
            icon: WSIcons.OverViewIcon,
          },
          
         
        
            // {
            //   id: 7,
            //   label: "Lab",
            //   icon: WSIcons.AllInclusiveOutlinedIcon,
            //   children: [
            //     {
            //       id: 21,
            //       label: "Lab Test & Packages ",
            //       path: "/labtestpackage/list",
            //     },
            //      {
            //       id: 21,
            //       label: "Lab Report",
            //       path: "/lab-report/list",
            //     },
            //      {
            //       id: 29,
            //       label: "Scanning Report",
            //       path: "/lab-scanning/list",
            //     },
            //     {
            //       id: 29,
            //       label: "Scan Category",
            //       path: "/scan-test/list",
            //     },
            //     {
            //       id: 36,
            //       label: "Lab Overview",
            //       path: "/lab-overview",
            //     },
            //     {
            //       id: 37,
            //       label: "Lab Technician Management",
            //       path: "/lab-technician-manage/list",
            //     },
            //        {
            //       id: 38,
            //       label: "Lab Assign Order",
            //       path: "/lab-assign-order",
            //     },
            //        {
            //       id: 39,
            //       label: "Lab Technician Details",
            //       path: "/lab-technician-details",
            //     },
            //      {
            //       id: 40,
            //       label: "Schedule Management",
            //       path: "/lab-schedule",
            //     },
            //   ],
            // },

            {
              id: 7,
              label: "Scanning",
              icon: WSIcons.AllInclusiveOutlinedIcon,
              children: [
                
                 {
                  id: 29,
                  label: "Scanning Report",
                  path: "/lab-scanning/list",
                },
                {
                  id: 29,
                  label: "Scan Category",
                  path: "/scan-test/list",
                },
                
              ],
            },
            // {
            //   id: 5,
            //   label: " Orders",
            //   icon: WSIcons.OrdersIcon,
            //   children: [
            //     {
            //       id: 22,
            //       label: "Lab Orders ",
            //       path: "/lab-orders/list",
            //     },
               
                
            //   ],
            // },
           
             
            // {
            //             id: 6,
            //             label: "Payments",
            //             icon: WSIcons.PaymentsIcon,
            //             children: [

        ],
  };
};
